<template >
    <div style="background-color: #F9F9F9; height: 100vh;">
        <div class="mx-2  pt-2 ">
                        <div class="flex justify-between mt-10 md:mt-0 items-baseline	">
                <h1 style="font-weight: 550;" class="text-2xl  mb-5 md:mt-10 mt-3">Shifts</h1>
                <router-link v-if="hasCreateShiftPermission" to="/craete-staff" style="background: #2E2C72;"
                    class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-regal-blue dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Create
                    Shift
                </router-link>
            </div>
            <div class="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between  pb-4">
                <div>
                     <span class="text-base ">
                        show:
            <select class="rounded-lg" id="quantity" @change="fetchShifts" v-model="number" name="quantity"
              style="border: 1px solid white; border-top: #F9F9F9;">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            &nbsp; entries
          </span>
                </div>
                <label for="table-search" class="sr-only">Search</label>
                <div class="relative ">
                    <div
                        class="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
                        <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor"
                            viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </div>
                    <input type="text" id="table-search"
                        class="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        v-model="searchQuery" @input="performSearch" placeholder="Search for items">
                </div>
            </div>
            <div class="qr-code-input flex-wrap flex justify-between md:mb-0 mb-5">
            </div>
            <div class="relative overflow-x-auto overflow-hidden  shadow-md ">
                <table class="w-full text-sm  border text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead class="text-xs text-gray-700  bg-stone-300 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" class="px-6 py-3">
                                Id
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Shift
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Start Time
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    End Time
                                    <a href="#"></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Created by
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Updated by
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Created at
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Updated at

                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3"  v-if="hasUpdateShiftPermission" >
                                <span class="flex items-center">Edit</span>
                            </th>
                            <th scope="col" class="px-6 py-3" v-if="hasDeleteShiftPermission" >
                                <span class="flex items-center">Delete</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="shift in shifts" :key="shift.id"
                            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                            <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{{ shift.id }}
                            </td>
                            <td class="px-6 py-4">{{ shift?.shift }}</td>
                            <td class="px-6 py-4">{{ shift?.start_time }}</td>
                            <td class="px-6 py-4">{{ shift?.end_time }}</td>
                            <td class="px-6 py-4">{{ shift?.created_by?.display_name }}</td>
                            <td class="px-6 py-4">{{ shift?.updated_by?.display_name }}</td>
                            <td class="px-6 py-4">{{ shift?.created_at }}</td>
                            <td class="px-6 py-4">{{ shift?.updated_at }}</td>
                            <td class="px-6 py-4 ">
                                <router-link v-if="hasUpdateShiftPermission" :to="'/edit-' + shift.id"
                                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Edit</router-link>
                            </td>
                            <td class="px-6 py-4 " v-if="hasDeleteShiftPermission" style="cursor: pointer;">
                                <a @click="delteshift(shift.id)" style="color: red;"
                                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Delete</a>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
            <div class="flex mt-10 justify-between">
                <span>
                    Showing 1 to 10
                </span>
                <nav aria-label="Page navigation example">
                    <ul class="inline-flex -space-x-px text-sm">
                        <li>
                            <a href="#"
                                class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white   hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">{{
                                    currentPages }}</a>
                        </li>
                        <li>
                            <a href="#" @click="handleLoadMore"
                                class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white   rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Next</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useShiftsStore } from '@/store/reports';
import { onMounted, ref, computed, watch ,onUnmounted} from 'vue';
import Swal from 'sweetalert2';
const loadMore = computed(() => useShiftsStore().loadMoreUrl)
const currentPages1 = computed(() => useShiftsStore().currentPagess)
const totalpage = computed(() => useShiftsStore().totalpage)
const shiftsStore = useShiftsStore(); // Use the shifts store
const chunk = ref(1)
const shifts = ref([]); // Create a reactive reference to hold shifts data
const searchQuery = ref('');
const currentPages = ref()
const totalpages = ref()
const number = ref(10)
/* eslint-disable */
const fetchShifts = async () => {
    await shiftsStore.fetchShifts(chunk.value, number.value); // Fetch shifts data using the store
};

const performSearch = () => {
    const filteredShifts = shiftsStore.shifts.filter((shift) =>
        shift.shift.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
    shifts.value = filteredShifts;
};
const delteshift = async (id) => {
    const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this shift?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    });

    if (confirmed.isConfirmed) {
        try {
            await shiftsStore.deleteshift(id);
            await fetchShifts(); // Assuming fetchShifts is an async function to refresh data after deletion
            Swal.fire(
                'Deleted!',
                'Your shift has been deleted.',
                'success'
            );
        } catch (error) {
            console.error('Failed to delete shift:', error);
            Swal.fire(
                'Error!',
                'Failed to delete shift.',
                'error'
            );
        }
    }
};

// eslint-disable-next-line no-unused-vars
const handleLoadMore = () => {
    if (loadMore.value) {
        chunk.value = chunk.value + 1
        useShiftsStore().fetchShifts(chunk.value)
    }
}
currentPages.value = currentPages1
totalpages.value = totalpage
// Load shifts data on component mount
onMounted(() => {
    fetchShifts();
});

// Watch for changes in shifts data from the store
watch(
    () => shiftsStore.shifts,
    (newShifts) => {
        shifts.value = newShifts;
    }
);

import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const permissions = ref([])
onMounted(() => {
    permissions.value = authStore.authData.permissions

});

const hasCreateShiftPermission = computed(() => permissions.value.some(permission => permission.name === 'can create shift'));
const hasUpdateShiftPermission = computed(() => permissions.value.some(permission => permission.name === 'can update shift'));
const hasDeleteShiftPermission = computed(() => permissions.value.some(permission => permission.name === 'can delete shift'));

onMounted(async()=>{
  await authStore.handlepermission()
})

onUnmounted(async()=>{
  await authStore.handlepermission()
})

</script>


<style scoped>
tbody tr {
    border-left: 2px solid #B9BBBD !important;
    border: 1px solid #B9BBBD;
}
</style>